// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tutorial-dialogue {
  position: fixed;
  left: 20px;
  background-color: #242b37;
  color: #e0e0e0;
  padding: 1vh 1vw;
  border-radius: 0.5vw;
  width: 20vw;
  max-width: 600px;
  z-index: 1000;
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  border: 0.1vw solid #00ffff;
  box-shadow: 
    0 0 10px rgba(0, 255, 255, 0.3),
    0 0 20px rgba(0, 255, 255, 0.2),
    inset 0 0 8px rgba(0, 255, 255, 0.2);
  box-sizing: border-box;
  overflow-x: hidden;
  animation: dialogueGlow 2s ease-in-out infinite;
}

.tutorial-dialogue.visible {
  opacity: 1;
}

.tutorial-dialogue-avatar {
  width: 5.5vw;
  height: 5.5vw;
  max-width: 66px;
  max-height: 66px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  margin-right: 1.5vw;
  flex-shrink: 0;
  border: 0.2vw solid #00ffff;
  box-shadow: 0 0.1vw 0.2vw rgba(0, 0, 0, 0.1);
  animation: pulse 2s infinite;
}

@media (max-width: 768px) {
  .tutorial-dialogue-avatar {
    width: 10vw;
    height: 10vw;
    max-width: 72px;
    max-height: 72px;
    min-width: 48px;
    min-height: 48px;
  }
}

.tutorial-dialogue-content {
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0.5vw;
}

.tutorial-dialogue-speaker {
  font-size: 0.9vw;
  font-weight: bold;
  color: #00ffff;
  margin-bottom: 0.1vw;
  text-transform: uppercase;
  letter-spacing: 0.03vw;
  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.2);
}

.tutorial-dialogue p {
  margin: 0;
  font-size: 1.2vw;
  line-height: 1.3;
  color: #e0e0e0;
  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.1);
  max-height: 15vh;
  overflow-y: auto;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0);
  }
}

.tutorial-dialogue-next {
  position: absolute;
  bottom: 1vh;
  right: 1vw;
  background-color: rgba(0, 255, 255, 0.1);
  color: #00ffff;
  border: 1px solid #00ffff;
  border-radius: 20px;
  padding: 0.5vh 1vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9vw;
  min-width: 60px;
  z-index: 1;
  animation: buttonPulse 1.5s ease-in-out infinite;
  background: linear-gradient(45deg, rgba(0, 255, 255, 0.1), rgba(0, 255, 255, 0.2));
}

.tutorial-dialogue-next:hover {
  background-color: rgba(0, 255, 255, 0.2);
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.tutorial-dialogue-next:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 255, 255, 0.5);
}

.tutorial-dialogue-next-text {
  margin-right: 0.5vw;
}

.tutorial-dialogue-next-arrow {
  width: 0;
  height: 0;
  border-left: 0.5vw solid currentColor;
  border-top: 0.3vw solid transparent;
  border-bottom: 0.3vw solid transparent;
  animation: arrowBounce 1s ease-in-out infinite;
}

@media (max-width: 768px) {
  .tutorial-dialogue {
    width: 40vw;
    padding: 1.5vh 2vw;
  }

  .tutorial-dialogue-content {
    padding-right: 1vw;
  }

  .tutorial-dialogue-speaker {
    font-size: 2vw;
  }

  .tutorial-dialogue p {
    font-size: 2.5vw;
    max-height: 20vh;
  }

  .tutorial-dialogue-next {
    font-size: 2.5vw;
    padding: 1vh 2vw;
    min-width: 80px;
  }

  .tutorial-dialogue-next-arrow {
    border-left: 1vw solid currentColor;
    border-top: 0.7vw solid transparent;
    border-bottom: 0.7vw solid transparent;
  }
}

.tutorial-dialogue-message {
  margin: 0;
  line-height: 1.3;
  color: #e0e0e0;
  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.1);
  max-height: 15vh;
  overflow-y: auto;
  /* padding-right: 3vw; */
  animation: textFadeIn 0.5s ease-out;
}

/* Add a custom scrollbar style for webkit browsers */
.tutorial-dialogue-message::-webkit-scrollbar {
  width: 0.5vw;
}

.tutorial-dialogue-message::-webkit-scrollbar-track {
  background: rgba(0, 255, 255, 0.1);
}

.tutorial-dialogue-message::-webkit-scrollbar-thumb {
  background-color: rgba(0, 255, 255, 0.5);
  border-radius: 0.25vw;
}

@media (max-width: 768px) {
  .tutorial-dialogue-message {
    font-size: 2.5vw;
    max-height: 20vh;
    padding-right: 4vw;
  }
}

/* Make the next button more compact on mobile */
@media screen and (max-width: 768px) {
  .tutorial-dialogue {
    padding: 10px; /* Reduce padding on mobile if needed */
  }
  
  .tutorial-dialogue-next {
    padding: 8px; /* Smaller padding for the button */
  }
}

.tutorial-dialogue.bottom {
  bottom: 20px;
}

.tutorial-dialogue.top {
  position: fixed;
  margin-left: 2vw;
  margin-top: 4vw;
}

@keyframes dialogueGlow {
  0% {
    box-shadow: 
      0 0 10px rgba(0, 255, 255, 0.3),
      0 0 20px rgba(0, 255, 255, 0.2),
      inset 0 0 8px rgba(0, 255, 255, 0.2);
  }
  50% {
    box-shadow: 
      0 0 15px rgba(0, 255, 255, 0.4),
      0 0 30px rgba(0, 255, 255, 0.3),
      inset 0 0 12px rgba(0, 255, 255, 0.3);
  }
  100% {
    box-shadow: 
      0 0 10px rgba(0, 255, 255, 0.3),
      0 0 20px rgba(0, 255, 255, 0.2),
      inset 0 0 8px rgba(0, 255, 255, 0.2);
  }
}

@keyframes buttonPulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(0, 255, 255, 0.7);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
  }
}

@keyframes textFadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes arrowBounce {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(3px);
  }
}
 `, "",{"version":3,"sources":["webpack://./src/styles/components/TutorialDialogue.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gEAAgE;EAChE,2BAA2B;EAC3B;;;wCAGsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,wCAAwC;EACxC,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gDAAgD;EAChD,kFAAkF;AACpF;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mCAAmC;IACnC,mCAAmC;IACnC,sCAAsC;EACxC;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,qDAAqD;AACrD;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa,EAAE,uCAAuC;EACxD;;EAEA;IACE,YAAY,EAAE,mCAAmC;EACnD;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE;;;0CAGsC;EACxC;EACA;IACE;;;2CAGuC;EACzC;EACA;IACE;;;0CAGsC;EACxC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,2CAA2C;EAC7C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".tutorial-dialogue {\n  position: fixed;\n  left: 20px;\n  background-color: #242b37;\n  color: #e0e0e0;\n  padding: 1vh 1vw;\n  border-radius: 0.5vw;\n  width: 20vw;\n  max-width: 600px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\n  border: 0.1vw solid #00ffff;\n  box-shadow: \n    0 0 10px rgba(0, 255, 255, 0.3),\n    0 0 20px rgba(0, 255, 255, 0.2),\n    inset 0 0 8px rgba(0, 255, 255, 0.2);\n  box-sizing: border-box;\n  overflow-x: hidden;\n  animation: dialogueGlow 2s ease-in-out infinite;\n}\n\n.tutorial-dialogue.visible {\n  opacity: 1;\n}\n\n.tutorial-dialogue-avatar {\n  width: 5.5vw;\n  height: 5.5vw;\n  max-width: 66px;\n  max-height: 66px;\n  min-width: 44px;\n  min-height: 44px;\n  border-radius: 50%;\n  margin-right: 1.5vw;\n  flex-shrink: 0;\n  border: 0.2vw solid #00ffff;\n  box-shadow: 0 0.1vw 0.2vw rgba(0, 0, 0, 0.1);\n  animation: pulse 2s infinite;\n}\n\n@media (max-width: 768px) {\n  .tutorial-dialogue-avatar {\n    width: 10vw;\n    height: 10vw;\n    max-width: 72px;\n    max-height: 72px;\n    min-width: 48px;\n    min-height: 48px;\n  }\n}\n\n.tutorial-dialogue-content {\n  flex: 1;\n  min-width: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 0.5vw;\n}\n\n.tutorial-dialogue-speaker {\n  font-size: 0.9vw;\n  font-weight: bold;\n  color: #00ffff;\n  margin-bottom: 0.1vw;\n  text-transform: uppercase;\n  letter-spacing: 0.03vw;\n  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.2);\n}\n\n.tutorial-dialogue p {\n  margin: 0;\n  font-size: 1.2vw;\n  line-height: 1.3;\n  color: #e0e0e0;\n  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.1);\n  max-height: 15vh;\n  overflow-y: auto;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(0, 255, 255, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0);\n  }\n}\n\n.tutorial-dialogue-next {\n  position: absolute;\n  bottom: 1vh;\n  right: 1vw;\n  background-color: rgba(0, 255, 255, 0.1);\n  color: #00ffff;\n  border: 1px solid #00ffff;\n  border-radius: 20px;\n  padding: 0.5vh 1vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9vw;\n  min-width: 60px;\n  z-index: 1;\n  animation: buttonPulse 1.5s ease-in-out infinite;\n  background: linear-gradient(45deg, rgba(0, 255, 255, 0.1), rgba(0, 255, 255, 0.2));\n}\n\n.tutorial-dialogue-next:hover {\n  background-color: rgba(0, 255, 255, 0.2);\n  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);\n}\n\n.tutorial-dialogue-next:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 255, 255, 0.5);\n}\n\n.tutorial-dialogue-next-text {\n  margin-right: 0.5vw;\n}\n\n.tutorial-dialogue-next-arrow {\n  width: 0;\n  height: 0;\n  border-left: 0.5vw solid currentColor;\n  border-top: 0.3vw solid transparent;\n  border-bottom: 0.3vw solid transparent;\n  animation: arrowBounce 1s ease-in-out infinite;\n}\n\n@media (max-width: 768px) {\n  .tutorial-dialogue {\n    width: 40vw;\n    padding: 1.5vh 2vw;\n  }\n\n  .tutorial-dialogue-content {\n    padding-right: 1vw;\n  }\n\n  .tutorial-dialogue-speaker {\n    font-size: 2vw;\n  }\n\n  .tutorial-dialogue p {\n    font-size: 2.5vw;\n    max-height: 20vh;\n  }\n\n  .tutorial-dialogue-next {\n    font-size: 2.5vw;\n    padding: 1vh 2vw;\n    min-width: 80px;\n  }\n\n  .tutorial-dialogue-next-arrow {\n    border-left: 1vw solid currentColor;\n    border-top: 0.7vw solid transparent;\n    border-bottom: 0.7vw solid transparent;\n  }\n}\n\n.tutorial-dialogue-message {\n  margin: 0;\n  line-height: 1.3;\n  color: #e0e0e0;\n  text-shadow: 0 0.03vw 0.03vw rgba(0, 0, 0, 0.1);\n  max-height: 15vh;\n  overflow-y: auto;\n  /* padding-right: 3vw; */\n  animation: textFadeIn 0.5s ease-out;\n}\n\n/* Add a custom scrollbar style for webkit browsers */\n.tutorial-dialogue-message::-webkit-scrollbar {\n  width: 0.5vw;\n}\n\n.tutorial-dialogue-message::-webkit-scrollbar-track {\n  background: rgba(0, 255, 255, 0.1);\n}\n\n.tutorial-dialogue-message::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 255, 255, 0.5);\n  border-radius: 0.25vw;\n}\n\n@media (max-width: 768px) {\n  .tutorial-dialogue-message {\n    font-size: 2.5vw;\n    max-height: 20vh;\n    padding-right: 4vw;\n  }\n}\n\n/* Make the next button more compact on mobile */\n@media screen and (max-width: 768px) {\n  .tutorial-dialogue {\n    padding: 10px; /* Reduce padding on mobile if needed */\n  }\n  \n  .tutorial-dialogue-next {\n    padding: 8px; /* Smaller padding for the button */\n  }\n}\n\n.tutorial-dialogue.bottom {\n  bottom: 20px;\n}\n\n.tutorial-dialogue.top {\n  position: fixed;\n  margin-left: 2vw;\n  margin-top: 4vw;\n}\n\n@keyframes dialogueGlow {\n  0% {\n    box-shadow: \n      0 0 10px rgba(0, 255, 255, 0.3),\n      0 0 20px rgba(0, 255, 255, 0.2),\n      inset 0 0 8px rgba(0, 255, 255, 0.2);\n  }\n  50% {\n    box-shadow: \n      0 0 15px rgba(0, 255, 255, 0.4),\n      0 0 30px rgba(0, 255, 255, 0.3),\n      inset 0 0 12px rgba(0, 255, 255, 0.3);\n  }\n  100% {\n    box-shadow: \n      0 0 10px rgba(0, 255, 255, 0.3),\n      0 0 20px rgba(0, 255, 255, 0.2),\n      inset 0 0 8px rgba(0, 255, 255, 0.2);\n  }\n}\n\n@keyframes buttonPulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 5px rgba(0, 255, 255, 0.5);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 0 15px rgba(0, 255, 255, 0.7);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 5px rgba(0, 255, 255, 0.5);\n  }\n}\n\n@keyframes textFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes arrowBounce {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  50% {\n    transform: translateX(3px);\n  }\n}\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
